import { call, put } from 'redux-saga/effects';
import {
  checkPermissionRequest,
  checkPermissionSuccess,
  checkPermissionFailure,
} from '../actions';
import { urls } from '../constants/constants';
import * as SagaTypes from './saga-types';
import * as Api from '../api';

export function* checkPermissionByUser(action) {
  yield put(checkPermissionRequest());

  try {
    const result = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/user/checkPermissions`
    );
    if (result && result.data && result.data.data) {
      action.callback(result.data.data);
      yield put(checkPermissionSuccess());
    } else {
      yield put(checkPermissionFailure('Something went Wrong'));
    }
  } catch (e) {
    console.error(e);
    yield put(checkPermissionFailure(e));
  }
}

export const checkPermissionSagaAction = (param, cb) => ({
  type: SagaTypes.CHECK_USER_PERMISSION,
  payload: { param },
  callback: cb,
});
